export enum NotFundedReason {
    abortedProcess = 'abortedProcess',
    financedByPreviousService = 'financedByPreviousService',
    freeOfCharge = 'freeOfCharge',
    fundedByOldPatientInvoicing = 'fundedByOldPatientInvoicing',
    isAlternativeFinancing = 'isAlternativeFinancing',
    manual = 'manual',
    migration = 'migration',
    noConsentPatient = 'noConsentPatient',
    noDeclarationSetForInsurerService = 'noDeclarationSetForInsurerService',
    noFundingDueToActivitySettings = 'noFundingDueToActivitySettings',
    noInsurersConfigured = 'noInsurersConfigured',
    notFunded = 'notFunded',
    parallelDeclaration = 'parallelDeclaration',
    serviceNotFundable = 'serviceNotFundable',
    uninsuredOrNonBillableActivity = 'uninsuredOrNonBillableActivity',
}
